import { useEffect, useState } from "react";
import {
  FormData as SchemaFormData,
  FormError,
  FormSchema,
  getErrorFieldIds,
  getVisibleFieldIds,
  InputElementClassUnion,
} from "@graffer-inc/form-schema";
import { isInputElement } from "@graffer-inc/form-schema";

type Props = {
  initial?: string[];
  schema: FormSchema;
  values: SchemaFormData;
  errors: FormError;
};

export const useConfirmFormEdit = ({
  initial,
  schema,
  values,
  errors,
}: Props) => {
  const [editIds, setEditIds] = useState<string[]>(initial || []);
  const onEdit = (elem: InputElementClassUnion, editing: boolean) => {
    const id = elem.formFieldId;
    const next = editing ? [...editIds, id] : editIds.filter((v) => v !== id);
    setEditIds(next);
  };

  useEffect(() => {
    const validKeys = getVisibleFieldIds(schema, values);
    const errorIds = getErrorFieldIds(errors);
    const formulaResultIds = schema
      .flattenDeep()
      .filter((e) => isInputElement(e) && e.inputType === "formula_result")
      .map((e) => e.formFieldId);
    const nextIds = editIds
      .filter((k) => validKeys.includes(k))
      .concat(errorIds)
      .filter((v, i, arr) => arr.indexOf(v) === i)
      .filter((v) => !formulaResultIds.includes(v));
    setEditIds(nextIds);
  }, [schema, values, errors]);

  return {
    editIds,
    onEdit,
  };
};
